import React from 'react';
import DynamicPracticePage from '../../components/common/DynamicPracticePage';
import { TopicItem } from '../../components/common/PracticeContentLayout';

const topics: TopicItem[] = [
  {
    id: 'introduction',
    title: 'Introduction',
    completed: false,
    children: [
      { id: 'intro-1', title: 'What is Docker?', completed: true },
      { id: 'intro-2', title: 'Containers vs Virtual Machines', completed: false },
      { id: 'intro-3', title: 'Docker Architecture', completed: false },
    ],
  },
  {
    id: 'fundamentals',
    title: 'Fundamentals',
    completed: false,
    children: [
      { id: 'installation', title: 'Installing Docker', completed: false },
      { id: 'dockerfile', title: 'Dockerfile Basics', completed: false },
      { id: 'images', title: 'Docker Images', completed: false },
      { id: 'containers', title: 'Docker Containers', completed: false },
      { id: 'docker-compose', title: 'Docker Compose', completed: false },
    ],
  },
  {
    id: 'advanced',
    title: 'Advanced Topics',
    completed: false,
    children: [
      { id: 'networking', title: 'Docker Networking', completed: false },
      { id: 'volumes', title: 'Volumes & Data Persistence', completed: false },
      { id: 'multi-stage', title: 'Multi-Stage Builds', completed: false },
      { id: 'optimization', title: 'Image Optimization', completed: false },
    ],
  },
];

const DockerPractice: React.FC = () => {
  return (
    <DynamicPracticePage
      topicType="docker"
      topics={topics}
      title="Master Docker"
    />
  );
};

export default DockerPractice;
